var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWithdrawMobile = function SvgWithdrawMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.429a.715.715 0 0 0-.714-.715H.714A.714.714 0 0 0 0 1.43v5.714a.715.715 0 0 0 .714.714h2.857v10.715a.715.715 0 0 0 .715.714h11.428a.715.715 0 0 0 .715-.715V7.857h2.857A.715.715 0 0 0 20 7.143V1.429Zm-5 16.428H5V5h10v12.857ZM18.572 6.43h-2.143V5h.357a.714.714 0 1 0 0-1.429H3.214a.714.714 0 1 0 0 1.429h.357v1.429H1.43V2.143H18.57v4.286Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.497 15.504a.715.715 0 0 0 1.007 0l2.478-2.475a.714.714 0 1 0-1.01-1.011l-1.258 1.257V7.857a.714.714 0 1 0-1.428 0v5.418l-1.257-1.257a.714.714 0 1 0-1.011 1.01l2.479 2.476Z",
    fill: "#666"
  })));
};
export default SvgWithdrawMobile;